<template>
  <b-card class="client-card mb-5">

    <h3 class="custom-title">{{ client.name }}
      <span class="right-down-arrow">
        <b-button
          :v-b-toggle="`${client.id}`"
          variant="outline-primary"
          class="right-down-arrow"
          size="sm"
          @click="showCollapse = !showCollapse">
          + Info
        </b-button>
      </span>
    </h3>

    <b-collapse :id="client.id" v-model="showCollapse">
      <ul class="list-unstyled">
        <li v-if="client.address" class="lead">
          <b class="text-muted">Dirección:</b> {{ client.address }}
        </li>
        <li v-if="client.phone" class="lead">
          <b class="text-muted">Teléfono: </b> <a href="tel:"> {{ client.phone }}</a>
        </li>
        <li v-if="client.paymentMethod" class="lead">
          <b class="text-muted">Forma Pago:</b> {{ client.paymentMethod }}
        </li>
        <li v-if="client.notes" class="lead">
          <b class="text-muted">Notas:</b>
          <p> {{ client.notes }}</p>
        </li>
        <li class="lead">
          <b class="text-muted">Horario de Entrega:
          </b>
          <ul>
            <li
              v-for="(schedule, idx) in client.deliverySchedule"
              :key="idx">
              <b-badge>{{ schedule.startTime }}</b-badge>
              <b> · </b>
              <b-badge>{{ schedule.endTime }}</b-badge>
            </li>
          </ul>
        </li>
        <li class="lead">
          <b class="text-muted">Frecuencia Entrega</b>
          <ul>
            <li v-for="(item, idx) in client.deliveryFrequency" :key="idx">
              {{ deliveryFrequencies[item] }}
            </li>
          </ul>
        </li>
      </ul>
      <hr>
    </b-collapse>

    <!-- Product / Prices -->
    <div class="mt-3 mb-3">
      <h3>Productos:</h3>
      <ul class="list-unstyled">
        <li
          class="bg-light p-2 mb-3 rounded"
          v-for="(product, idx) in client.productPrices"
          :key="idx">
          <h5 class="mb-0">{{ products[product.id].name }}</h5>
          <p class="mb-0 lead"> Precio: <b-badge variant="info">{{ product.price }} €</b-badge></p>
          <p class="lead"> Previsión: <b-badge> {{ getPrevision(product.id) }}</b-badge></p>
          <b-form>
            <b-form-group
              :id="`group-product-${idx}`"
              description="Cantidad Entregada"
              label="Total Entregado:"
              :label-for="`client-${client.id}-product-${product.id}`">
              <b-form-input
                :id="`client-${client.id}-product-${product.id}`"
                :name="`client-${client.id}-product-${product.id}`"
                v-model="deliveredProducts[product.id]"
                type="number"
                v-validate="'required|min_value:0|decimal:2'"
                :state="errors.first(`client-${client.id}-product-${product.id}`) ? 'invalid' : ''"
                size="sm"
                placeholder="Cantidad Entregada"
                trim>
              </b-form-input>
              <span v-if="errors.has(`client-${client.id}-product-${product.id}`)" class="text-danger">Valor Incorrecto</span>
            </b-form-group>
            <div class="d-flex justify-content-end">
              <b-button size="sm" variant="primary" @click="saveQuantity(product.id, client.id, idx)">Guardar Cantidad</b-button>
            </div>
            <br>
          </b-form>
        </li>
      </ul>
    </div>

    <!-- Calcular precio -->
    <div>
      <h4 class="text-muted border-bottom">FACTURA</h4>
      <div class="d-flex justify-content-end mb-4">
        <b-button variant="info" @click="calculatePrice()">Calcular Precio</b-button>
      </div>
      <div v-if="showTotal">
        <ul class="mb-0">
          <ProductPriceQtty :data="t" v-for="(t, idx) in total" :key="idx" />
        </ul>

        <FinalPrice :total="calculateTotalPrice"/>
      </div>
    </div>

    <!-- Albarán -->
    <div>
      <hr class="my-5">
      <h4 class="resalto">ALBARÁN:</h4>
      <b-form :data-vv-scope="`delivery-note-form-client-${client.id}`">
        <b-form-group
          :id="`group-deliveryNote-client-${client.id}`"
          label="Nº ALBARÁN:"
          label-for="deliveryNote">
          <b-form-input
            id="deliveryNote"
            name="deliveryNote"
            v-model="deliveryNote"
            type="text"
            v-validate="'required'"
            :state="errors.first(`delivery-note-form-client-${this.client.id}.deliveryNote`) ? 'invalid' : ''"
            size="sm"
            placeholder="Nº Albarán"
            trim>
          </b-form-input>
          <span class="text-danger">{{ errors.first(`delivery-note-form-client-${this.client.id}.deliveryNote`) }}</span>
        </b-form-group>

        <b-form-group :id="`group-isDeliveryPaid-client-${client.id}`" label="¿HA PAGADO EN MANO?">
          <b-form-radio-group
            :id="`isDeliveryPaid-client-${client.id}`"
            :name="`isDeliveryPaid-client-${client.id}`"
            v-model="isDeliveryPaid"
            :options="optionsIsDeliveryPaid"
          ></b-form-radio-group>
        </b-form-group>

        <b-form-group
          v-if="isDeliveryPaid"
          :id="`group-paidQuantity-client-${client.id}`"
          label="¿CANTIDAD PAGADA?:"
          :label-for="`paidQuantity-client-${client.id}`">
          <b-form-input
            :id="`paidQuantity-client-${client.id}`"
            :name="`paidQuantity-client-${client.id}`"
            v-model="paidQuantity"
            type="number"
            v-validate="'required|min_value:0|decimal:2'"
            :state="errors.first(`delivery-note-form-client-${this.client.id}.paidQuantity-client-${client.id}`) ? 'invalid' : ''"
            size="sm"
            placeholder="Cantidad Pagada"
            trim>
          </b-form-input>
          <span class="text-danger">{{ errors.first(`delivery-note-form-client-${this.client.id}.paidQuantity-client-${client.id}`) }}</span>
        </b-form-group>

        <div class="d-flex justify-content-end">
          <b-button size="sm" variant="primary" @click="saveDeliveryNote()">Guardar Albarán</b-button>
        </div>
      </b-form>
    </div>

    <!-- Comentarios -->
    <div>
      <hr class="my-5">
      <h4 class="resalto">COMENTARIOS:</h4>
      <b-form>
        <b-form-group
          :id="`group-comment-${client.id}`"
          label="Comentarios:"
          :label-for="`deliveryComment-client${client.id}`">
          <b-form-textarea
            :id="`deliveryComment-client${client.id}`"
            :name="`deliveryComment-client${client.id}`"
            v-model="deliveryComment"
            v-validate="'required'"
            :state="errors.first(`deliveryComment-client${client.id}`) ? 'invalid' : ''"
            placeholder="Notas o comentarios"
            rows="2"
            max-rows="4"
          ></b-form-textarea>
          <span class="text-danger">{{ errors.first(`deliveryComment-client${client.id}`) }}</span>
        </b-form-group>

        <div class="d-flex justify-content-end">
          <b-button size="sm" variant="primary" @click="saveDeliveryComment()">Guardar Comentario</b-button>
        </div>
      </b-form>
    </div>

    <!-- Estado Entrega a un cliente -->
    <div>
      <hr>
      <h4 class="resalto">Estado Entrega:</h4>
      <b-form>
        <b-form-group>
          <b-form-radio-group
            :id="`group-deliveryStatus-client-${client.id}`"
            :name="`group-deliveryStatus-client-${client.id}`"
            v-model="deliveryStatus"
            :options="optionsDeliveryStatus"
          ></b-form-radio-group>
        </b-form-group>
      </b-form>
    </div>

  </b-card>
</template>

<script>
import { dateMixin } from '@/mixins/dateMixin'
import ProductPriceQtty from './ClientCardProductPriceQtty'
import FinalPrice from './ClientCardFinalPrice'

export default {
  name: 'ClientCard',
  components: { FinalPrice, ProductPriceQtty },
  mixins: [dateMixin],
  props: {
    routeData: {
      type: Object,
      required: true
    },
    client: {
      type: Object,
      required: true
    },
    products: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      deliveredProducts: {},
      deliveryNote: '',
      deliveryComment: '',
      deliveryFrequencies: {
        weekly: 'Semanal',
        biweekly: 'Quincenal',
        call: 'Llama'
      },
      showCollapse: false,
      isDeliveryPaid: false,
      paidQuantity: null,
      deliveryStatus: null,
      optionsIsDeliveryPaid: [
        { text: 'NO', value: false },
        { text: 'SI', value: true }
      ],
      optionsDeliveryStatus: [
        { text: 'En curso', value: 'pending', disabled: true },
        { text: 'Entregado', value: 'delivered', disabled: true }
        // { text: 'Cancelado', value: 'cancelled' }
      ],
      showTotal: false,
      total: []
    }
  },
  created () {
    this.setDeliveredProducts()
    this.setDeliveryComment()
    this.setDeliveryNote()
  },
  computed: {
    calculateTotalPrice () {
      const list = []
      this.total.map((item) => {
        list.push(item.productPrice * item.deliveredQuantity)
      })
      return list.reduce((a, b) => a + b, 0)
    }
  },
  methods: {
    getPrevision (productId) {
      return this.routeData.prevision.products.find(p => p.productId === productId).quantity
    },
    saveDeliveryNote () {
      this.$validator.validateAll(`delivery-note-form-client-${this.client.id}`)
        .then((valid) => {
          if (valid) {
            const status = this.checkDeliveryClientStatus()
            this.deliveryStatus = status
            console.log('Status: ', status)
            // Emit
            const data = {
              clientId: this.client.id,
              deliveryNote: this.deliveryNote,
              // Pending · Delivered · Cancelled
              deliveryStatus: status,
              isDeliveryPaid: this.isDeliveryPaid,
              paidQuantity: this.isDeliveryPaid ? this.paidQuantity : null
            }
            this.$emit('saveDeliveryNote', data)
          }
        })
    },
    saveQuantity (productId, clientId, idx) {
      this.$validator.validate(`client-${clientId}-product-${productId}`)
        .then((valid) => {
          if (valid) {
            // Emit
            const data = {
              clientId,
              productId,
              deliveredQuantity: this.deliveredProducts[productId],
              updatedAt: this.currentDateMilliseconds(),
              updatedBy: 'demoUser'
            }
            this.$emit('saveQuantity', data)
          }
        })
    },
    saveDeliveryComment () {
      this.$validator.validate(`deliveryComment-client${this.client.id}`)
        .then((valid) => {
          if (valid) {
            // Emit
            const data = {
              clientId: this.client.id,
              deliveryComment: this.deliveryComment
            }
            this.$emit('saveDeliveryComment', data)
          }
        })
    },
    // Carga el modelo de productos entregados en la variable delivered que es la que tiene el formulario
    setDeliveredProducts () {
      Object.keys(this.routeData.deliveredProducts).map(i => {
        this.deliveredProducts[i] = this.routeData.deliveredProducts[i]
      })
    },
    // Carga los valores del albaran + datos de pago y demas en el modelo correspondiente
    setDeliveryNote () {
      this.paidQuantity = this.routeData.paidQuantity
      this.deliveryNote = this.routeData.deliveryNote
      this.isDeliveryPaid = this.routeData.isDeliveryPaid
      this.deliveryStatus = this.routeData.deliveryStatus
    },
    setDeliveryComment () {
      this.deliveryComment = this.routeData.deliveryComment
    },
    checkDeliveryClientStatus () {
      const s = {
        pending: 'pending',
        delivered: 'delivered',
        cancelled: 'cancelled'
      }
      if (this.deliveryStatus === 'cancelled') {
        return s.cancelled
      } else if (this.deliveryNote !== null && this.deliveryNote !== '') {
        return s.delivered
      } else {
        return s.pending
      }
    },
    calculatePrice () {
      this.showTotal = true
      this.total = []
      console.log(this.products)

      const entregados = Object.keys(this.routeData.deliveredProducts)
      entregados.map(i => {
        const p = this.products[i]
        // Buscar el precio en productPrices
        this.total.push({
          productId: p.id,
          productName: p.name,
          deliveredQuantity: this.routeData.deliveredProducts[p.id],
          productPrice: this.client.productPrices.find(price => price.id === p.id).price
        })
      })
    }
  }
}
</script>

<style lang="stylus">
.client-card
  h3.custom-title
    border-bottom: 6px solid #FFEB3B

  .custom-title
    span.right-down-arrow
      position absolute
      top 20px
      right 20px
      font-size 20px

  h4.resalto
    border-bottom 3px solid #9E9E9E

</style>
